// extracted by mini-css-extract-plugin
export default {"barBackground":"BarDisplay_barBackground__exJJO"};